import { render, staticRenderFns } from "./icon.vue?vue&type=template&id=4d141584&scoped=true&"
import script from "./icon.vue?vue&type=script&lang=ts&"
export * from "./icon.vue?vue&type=script&lang=ts&"
import style0 from "./icon.vue?vue&type=style&index=0&id=4d141584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d141584",
  null
  
)

export default component.exports